import * as gateway from 'sfx-web-contract';
import { DeepRequired } from '../../../types';
import { IMonitoringBody } from '../../../interfaces';

export function logEncode(logs: IMonitoringBody): Uint8Array {
    const fullRequest: DeepRequired<gateway.ILogRequest> = {
        Items: logs.streams.map(log => {
            return {
                Timestamp: log.timestamp,
                Attributes: log.attributes,
                Resource: log.resource,
                TraceId: log.traceId,
                SpanId: log.spanId,
                SeverityText: log.severityText,
                SeverityNumber: log.severityNumber,
                Body: log.body,
            };
        }),
    };

    const request = gateway.LogRequest.create(fullRequest);

    return gateway.LogRequest.encode(request).finish();
}
